import { Injectable } from "@angular/core";
import { OpsIntPromiseActionService } from "shared/cubiq-services";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { BfxConfigService } from "shared/auth-services/system-config/bfx-config.service";

@Injectable()
export class BfxOpsIntDialogsProcessorService {
  public config: any = {
    debug: false,
  };

  private configurationSubscription: Subscription;

  constructor(
    private _configService: BfxConfigService,
    private _translationService: TranslateService,
    private _opsIntActionService: OpsIntPromiseActionService,
  ) {
    this.subscribeToConfiguration();
  }

  private subscribeToConfiguration(): void {
    this.configurationSubscription = this._configService.uiConfig$.subscribe((config) => {
      this.config = config.general;
    });
  }

  public executeClear(event: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this._opsIntActionService
        .clear(event.referencedOpsIntIds, event.comments, event.externalDealId, {})
        .then(
          (response) => {
            logger.out.info(
              "INFO: BfxOpsIntDialogsProcessorService.executeClear(): response=",
              response,
            );
            resolve(response);
          },
          (rej) => {
            logger.out.error(
              "ERROR: BfxOpsIntDialogsProcessorService.executeClear(): rejected =",
              rej,
            );
            reject(rej);
          },
        );
    });
  }
}
